"use client"
import React, { useEffect, useState } from 'react';
import useMediaQuery from '../../hooks/useMediaQuery';
import DeepLinkSmsForm from './components/DeepLinkSmsForm';
import GroupCodePanel from './components/GroupCodePanel';
import StoreButtons from './components/StoreButtons';
import styles from './styles/deepLink.module.css';


const Deeplink = () => {

    const [groupCode, setGroupCode] = useState("");
    const isAboveMediumScreens = useMediaQuery("(min-width: 1060px)");
    const [deepLink, setDeepLink] = useState("");

    useEffect(() => {
        async function getInvitationLink(code) {
            const res = await fetch(process.env.NEXT_PUBLIC_PAYMENT_URL + "payment/invitationLink?code=" + code);

            if (res.ok) {
                let data = await res.json();

                if (data && data.invitationLink) {
                    setDeepLink(data.invitationLink);
                }
            }
        }

        let params = new URLSearchParams(document.location.search.substring(1));
        let code = params.get('code') ?? '';

        setGroupCode(code);
        getInvitationLink(code);

    }, []);

    return (
        <div className={styles.mainBgc}>
            <div className={styles.familyContainer}>
                <div className={styles.familyHeaderContainer}>
                    <h2 className={styles.familyHeader}>Please follow the instructions to install the app on your mobile device</h2>
                </div>

                {isAboveMediumScreens &&
                    <>
                        <DeepLinkSmsForm />
                        <h2>Or</h2>
                        <p className={styles.familySubtitle}>Download Device Tracker Plus from your device’s app store to finish setting up your account.</p>
                    </>
                }
                <StoreButtons link={deepLink} />
                {groupCode !== "" &&
                    <div className={styles.familyContainer}>
                        <>
                            <p className={styles.familySubtitle}><br /> This is your group code. Enter it in the app to sign into your account from any device. <br /></p>
                            <GroupCodePanel groupCode={groupCode} />
                        </>
                    </div>
                }
            </div>
        </div>

    )
}

export default Deeplink;